var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',_vm._b({directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onOutsideClick),expression:"onOutsideClick"}],class:[_vm.variant, { 'text-center': _vm.bigIcon == true }, 'icon-link'],attrs:{"href":_vm.to,"target":_vm.openInNewTab ? '_blank' : '_self',"rel":_vm.openInNewTab ? 'noopener noreferrer' : ''},on:{"click":_vm.onClick}},'b-link',{
    ..._vm.$attrs,
    title: _vm.title,
  },false),[_c('div',{class:{ 'd-flex align-items-center space-x-1': !_vm.linkText }},[(!_vm.svgIcon)?_vm._t("icon",function(){return [_c('i',{class:[
          _vm.iconPrefix,
          _vm.iconName,
          {
            'fa-2x big-icon mr-0': _vm.bigIcon,
            'mr-2': _vm.linkText,
          },
        ]})]}):_vm._t("svg-icon"),_vm._v(" "),_c('span',{class:[{ 'big-text': _vm.bigIcon == true }]},[(_vm.linkText)?_vm._t("linkText",function(){return [_vm._v(_vm._s(_vm.linkText))]}):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.hasDropdown)?_c('i',{class:`${_vm.iconPrefix} fa-sm fa-caret-${_vm.dropdownOpen ? 'up' : 'down'}`}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }